var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStationAirplaneWaltti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1997 28H2.8003C1.25347 28 0 26.7465 0 25.2007V2.8003C0 1.25347 1.25347 0 2.8003 0H25.1997C26.7465 0 28 1.25347 28 2.8003V25.2007C27.999 26.7465 26.7455 28 25.1997 28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9176 4.0824C23.0869 3.2517 20.576 4.41627 19.7453 5.24697L15.6214 9.37087L5.62035 8.09666C5.19759 8.04233 4.77286 8.18753 4.47159 8.48979L3.20331 9.75807L10.9305 14.6386L7.82404 18.1274L4.52098 18.2074C4.21774 18.2143 4.07155 18.5817 4.28589 18.7961L9.20394 23.7141C9.41828 23.9285 9.78474 23.7813 9.79264 23.479L9.87265 20.176L13.3614 17.0695L18.2419 24.7967L19.5102 23.5284C19.8115 23.2271 19.9567 22.8024 19.9033 22.3797L18.6301 12.3776L22.754 8.25371C23.5837 7.42399 24.7483 4.91311 23.9176 4.0824Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationAirplaneWaltti);
export default __webpack_public_path__ + "static/media/station-airplane-waltti.9b3be6b0ce4136dbef93873374c8d8d8.svg";
export { ForwardRef as ReactComponent };